// GraphQL sends `null` for missing values; the apps use `undefined` instead (the
// casino_core codegen types nullable fields as `T | undefined`), so every GraphQL
// response and subscription message goes through this once, when it's parsed.
// Object keys holding null are dropped; null array items become undefined.
const convert = (value: unknown): unknown => {
  if (value === null) return undefined;
  if (Array.isArray(value)) return value.map(convert);
  if (typeof value === "object") {
    const result: Record<string, unknown> = {};
    for (const [key, item] of Object.entries(value)) {
      if (item !== null) result[key] = convert(item);
    }
    return result;
  }
  return value;
};

// Typed as returning its input type, so parsed JSON (`any`) stays `any` and a
// typed response stays typed; the generated types already say `T | undefined`.
const nullsToUndefined = <T>(value: T): T => convert(value) as T;

export default nullsToUndefined;
